{
  "00945c89f76b547f": "Qualification",
  "0b3d8801e8101ab3": "Orientation block created",
  "14303aa0c4a08d39": "End date",
  "19766ed6ccb2f4a3": "Cancel",
  "4759498ac2a719c6": "Create",
  "59568730f215c863": "Failed to create orientation block",
  "5b4dee0fb8e18745": "Orientation block",
  "80625961671ca1f3": "Create orientation block",
  "8169693101a4536c": "Start date",
  "a7cba5fc45cdd4cf": "Notes for professionals (optional)",
  "ae65d096550ff4eb": "Capacity",
  "ea790973625add62": "Orientation blocks do not post to marketplace. Assignments are managed internally."
}
